module.exports = __webpack_public_path__ + "static/img/add-user.278cd705.svg";